import React from "react";
import { Button, ToggleSwitch } from "@abb/abb-common-ux-react";
import submitHeaderStore from "../../flux/stores/shared/SubmitHeaderStore";
import { ISubmitHeaderData } from "../../models/shared/SubmitHeaderData";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import history from "../../utilities/History";

interface ISubmitProps {
  name: string;
  isEdit: boolean;
  onSaveClick?: () => void;
  onCancelClick?: () => void;
  onCreateClick?: () => void;
  onManualClick?: (value: any) => void;
  showCreateManually?: boolean;
  isCreatedManually?: boolean;
  manualLabel?: string;
  isEditMode?: boolean;
  isLoading?: boolean;
  link?: string;
}

export default class SubmitHeader extends React.Component<
  ISubmitProps,
  { isSubmitDisabled: boolean }
> {
  _mount: boolean;

  static defaultProps: ISubmitProps = {
    showCreateManually: false,
    name: "",
    isEdit: false,
    isCreatedManually: false,
    isLoading: false,
  };

  constructor(props: ISubmitProps) {
    super(props);
    this.state = {
      isSubmitDisabled: true,
    };

    this._mount = false;
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    submitHeaderStore.on(CONSTANTS.CHANGE_EVENT, (state: ISubmitHeaderData) => {
      if (this._mount) {
        this.setState({
          isSubmitDisabled: state.isSubmitDisabled,
        });
      }
    });
  }

  public breadcrumpClick = (link: string): void => {
    if (link) {
      if (link.toString().toLocaleLowerCase().startsWith("/"))
        history.push(`${link}`);
      else history.push(`/${link}`);
    }
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="container-box mt-3 align-self-center rounded-sm rounded-lg submit-header-fixed submit-header-background">
            <div className="col-12">
              <div className="float-left">
                <div className="pl-3 pb-3 breadcrumb-font">
                  <span
                    className="cursor-pointer link-underline"
                    onClick={() => this.breadcrumpClick("samplenew")}
                  >
                    {t("Home")}
                  </span>
                  &nbsp;{">"}&nbsp;
                  {this.props.name !== CONSTANTS.MENU_SAMPLE && this.props.link && this.props.link.includes('accountmanagement')  ? ( <React.Fragment>
                      {t(CONSTANTS.MENU_ACCOUNT_MANAGEMENT)}
                      &nbsp;{">"}&nbsp;
                    </React.Fragment>) : this.props.name !== CONSTANTS.MENU_SAMPLE ? (
                    <React.Fragment>
                      {t("Configuration")}
                      &nbsp;{">"}&nbsp;
                    </React.Fragment>
                  ) :  <></> }
                  <span
                    className="cursor-pointer  link-underline"
                    onClick={() => this.breadcrumpClick(this.props?.link ?? "")}
                  >
                    {t(this.props.name)}
                  </span>
                  &nbsp;{">"}&nbsp;
                  {this.props.isEdit ? <span className="breadcrumb-font-bolder">{t(CONSTANTS.EDIT)}</span> : <span className="breadcrumb-font-bolder">{t(CONSTANTS.NEW)}</span>}
                </div>
              </div>
              <div className="float-right">
                <div className="float-left mt-1">
                  {this.props.showCreateManually ? (
                    <ToggleSwitch
                      label={t(this.props.manualLabel)}
                      showIcons={true}
                      className="spinner-position"
                      disabled={this.props.isEditMode ? true : false}
                      value={this.props.isCreatedManually}
                      onChange={(value) => this.props.onManualClick(value)}
                    />
                  ) : null}
                </div>
                <div className="float-right ml-5">
                  <Button
                    style={{ margin: "0px 4px" }}
                    type="primary-black"
                    shape="pill"
                    className="spinner-position"
                    text={t(CONSTANTS.BUTTON_CANCEL)}
                    icon="abb/close"
                    onClick={this.props.onCancelClick}
                  />
                  {this.props.isEdit ? (
                    <Button
                      disabled={this.state.isSubmitDisabled}
                      type="primary-black"
                      shape="pill"
                      className="spinner-position"
                      text={t(CONSTANTS.BUTTON_SAVE)}
                      icon="abb/check-mark"
                      onClick={this.props.onSaveClick}
                      isLoading={this.props.isLoading}
                    />
                  ) : (
                    <Button
                      disabled={this.state.isSubmitDisabled}
                      type="primary-black"
                      shape="pill"
                      text={t(CONSTANTS.CREATE)}
                      icon="abb/check-mark"
                      onClick={this.props.onCreateClick}
                      isLoading={this.props.isLoading}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
